export function prepareModerationIssues(response) {
  return {
    issues: response.issues
  };
}